const React = require('react');
const PropTypes = require('prop-types');
const { QueryRenderer, graphql } = require('react-relay');
const { BarHeader, ModalBody } = require('dibs-elements');
const OverlaySpinner = require('dibs-overlay-spinner');

const css = require('./ContactDealerRenderer.scss');

class MultiContactDealerModalRenderer extends React.Component {
    constructor() {
        super();
        this.isLoaded = false;
    }
    render() {
        const props = this.props;
        const {
            variables,
            modalProps,
            environment,
            forceEnvironmentUpdate,
            showMultiRequestModal,
            bulkHoldRequest,
        } = props;
        const { MultiRequestContactDealer, BulkHoldRequest } = modalProps.modalComponents;
        if (this.isLoaded) {
            return null;
        }

        return (
            <QueryRenderer
                environment={environment}
                variables={variables}
                query={graphql`
                    query MultiContactDealerModalRendererQuery(
                        $userId: String = ""
                        $userIds: [String]
                        $itemId: String = ""
                        $sellerId: String = ""
                        $hasSellerId: Boolean = false
                        $shouldFetchItem: Boolean!
                        $hasUserId: Boolean!
                        $zipCode: String = ""
                        $country: String = ""
                        $canCheckZipCode: Boolean = false
                    ) {
                        viewer {
                            ...MultiRequestContactDealer_viewer
                            ...BulkHoldRequest_viewer
                        }
                    }
                `}
                render={({ props: relayProps }) => {
                    if (relayProps) {
                        this.isLoaded = true;

                        const contactDealerProps = Object.assign(
                            {},
                            variables,
                            modalProps,
                            relayProps,
                            {
                                forceEnvironmentUpdate,
                            }
                        );

                        if (showMultiRequestModal) {
                            return <MultiRequestContactDealer {...props} {...contactDealerProps} />;
                        } else if (bulkHoldRequest) {
                            return <BulkHoldRequest {...props} {...contactDealerProps} />;
                        }

                        return null;
                    }

                    return (
                        <div>
                            <BarHeader title="Loading..." />
                            <ModalBody>
                                <OverlaySpinner
                                    additionalWrapperClasses={css.spinnerWrapper}
                                    position={'isRelative'}
                                />
                            </ModalBody>
                        </div>
                    );
                }}
            />
        );
    }
}

MultiContactDealerModalRenderer.propTypes = {
    variables: PropTypes.object,
    modalProps: PropTypes.object,
    environment: PropTypes.object.isRequired,
    forceEnvironmentUpdate: PropTypes.func,
};

module.exports = MultiContactDealerModalRenderer;



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/MultiContactDealerModalRenderer.jsx